import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { CryptoRewardsPanePreset } from 'components/features/rewards/rewardsPane/components/CryptoRewardsPanePreset/CryptoRewardsPanePreset'
import { cryptoMarketGuard } from 'components/features/rewards/rewardsPane/guards/cryptoCurrenciesMarketDataLoadedGuard'
import { cryptoMetaGuard } from 'components/features/rewards/rewardsPane/guards/cryptoMetaGuard'
import { rewardsSummaryGuard } from 'components/features/rewards/rewardsPane/guards/rewardsSummaryGuard'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import { FC } from 'react'


type LoadingPaneProps = {
  onClose: () => void

}

export const LoadingPane: FC<LoadingPaneProps> = (props) => {
  const { onClose } = props

  useSimpleGuard(rewardsSummaryGuard, props, 'LoadingPane')
  useSimpleGuard(cryptoMetaGuard, props, 'LoadingPane')
  useSimpleGuard(cryptoMarketGuard, props, 'LoadingPane')


  return (
    <CryptoRewardsPanePreset
      title='Sell Your Crypto Investments'
      onCancel={ onClose }
    >
      <LoadingOverlay />
    </CryptoRewardsPanePreset>
  )
}
